import {
  addDays,
  todayBusinessDate,
  toPrismaDate,
  TRANSFER_ORDER_ARRIVING_WINDOW_DAYS,
} from '@nudool/shared';

import type { TransferOrderWhere } from '../transfer-order-list-operations.js';
import type { TransferOrderWorkspaceQueue } from '../transfer-order-workspace-queues.js';

/** Bounds at UTC midnight of the Pacific business day, the same "today" the metrics tiles count against. */
export function buildTransferOrderQueueWhere(
  queue: TransferOrderWorkspaceQueue,
  now: Date,
): Pick<TransferOrderWhere, 'dateScheduled'> {
  const today = todayBusinessDate(now);
  const todayStart = toPrismaDate(today).toISOString();
  switch (queue) {
    case 'late':
      return { dateScheduled: { lt: todayStart } };
    case 'arrivingThisWeek':
      return {
        dateScheduled: {
          gte: todayStart,
          lt: toPrismaDate(addDays(today, TRANSFER_ORDER_ARRIVING_WINDOW_DAYS)).toISOString(),
        },
      };
    default:
      return {};
  }
}
